export enum IOptionGroupIndex {
  Location = 1,
  Facility = 2,
}
